<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('sticky-header');
  if (!header) return;

  const trigger = 60; // scroll distance

  window.addEventListener('scroll', () => {
    if (window.scrollY > trigger) {
      header.classList.add('stuck');
    } else {
      header.classList.remove('stuck');
    }
  });
});
